import { render } from "./MemberCard.vue?vue&type=template&id=437d6a0e&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"

import "./MemberCard.vue?vue&type=style&index=0&id=437d6a0e&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437d6a0e"]])

export default __exports__